import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { RootLayout } from "../root/root.component";
import { logintTypeCorpo, logintTypeInd } from "../../../common/constant";
declare var pg: any;
@Component({
  selector: "executive-layout",
  templateUrl: "./executive.component.html",
  styleUrls: ["./executive.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ExecutiveLayout extends RootLayout implements OnInit {
  menuItems = [];
  ngOnInit() {
    if (this.authService.userData.type === logintTypeCorpo) {
      this.menuItems.push({
        label: "116m",
        descr: "Tag List",
        details: "",
        routerLink: "/tag/corp/list",
        iconType: "pg",
        iconName: "home",
        adminU: false,
      });
      this.menuItems.push({
        label: "118",
        descr: "Profile",
        details: "",
        routerLink: "/tag/corp/profile",
        iconType: "pg",
        iconName: "user",
        adminU: false,
      });
      if (
        this.authService.userData.oa === false &&
        !this.authService.isAdminU()
      ) {
        this.menuItems.push({
          label: "597",
          descr: "Hist Log",
          details: "",
          routerLink: "/admin/log",
          iconType: "pg",
          iconName: "user",
          adminU: false,
        });
      }
    } else if (this.authService.userData.type === logintTypeInd) {
      this.menuItems.push({
        label: "118",
        descr: "Profile",
        details: "",
        routerLink: "/tag/ind/profile",
        iconType: "pg",
        iconName: "user",
        adminU: false,
      });
    }

    if (this.authService.isAdminU()) {
      this.menuItems.push({
        label: "9",
        descr: "Create",
        details: "",
        routerLink: "/admin/create",
        iconType: "pg",
        iconName: "user",
        adminU: true,
      });
      this.menuItems.push({
        label: "595",
        descr: "Corp List",
        details: "",
        routerLink: "/admin/list/corp",
        iconType: "pg",
        iconName: "user",
        adminU: true,
      });
      this.menuItems.push({
        label: "596",
        descr: "Ind.List",
        details: "",
        routerLink: "/admin/list/ind",
        iconType: "pg",
        iconName: "user",
        adminU: true,
      });
      this.menuItems.push({
        label: "597",
        descr: "Hist Log",
        details: "",
        routerLink: "/admin/log",
        iconType: "pg",
        iconName: "user",
        adminU: true,
      });
      this.menuItems.push({
        label: "594",
        descr: "Config",
        details: "",
        routerLink: "/admin/config",
        iconType: "pg",
        iconName: "user",
        adminU: true,
      });
    }

    //
    // this.menuItems.push( {
    //     label:"11",
    //     descr:'Sold',
    //     details:"",
    //     routerLink:"/tag/sold",
    //     iconType:"pg",
    //     iconName:"user",
    //     adminU: true
    // });
    // this.menuItems.push( {
    //     label:"39",
    //     descr:'Stolen',
    //     details:"",
    //     routerLink:"/tag/stolen",
    //     iconType:"pg",
    //     iconName:"user",
    //     adminU: true
    // });
    pg.isHorizontalLayout = true;
    this.changeLayout("horizontal-menu");
    this.changeLayout("horizontal-app-menu");
  }

  goHome() {
    this.authService.goToHome();
  }
}
